// extracted by mini-css-extract-plugin
export default {"flex":"profile-tabs_flex__ULHh-","link":"profile-tabs_link__Ib+xH"};